module.exports = __webpack_public_path__ + "img/ptu-1.44f86787.png";